<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter" id="_idContainer003" role="doc-chapter">
<p class="pl-title"><a id="_idTextAnchor001"></a>Texas Cinderella</p>
<p class="pl-author">Winnie Griggs</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Texas_Cinderella.vue?4bc1093e